module.exports = __webpack_public_path__ + "static/media/green_animal_amphibians_6.358a4f84.webp";